import { apiClient } from './apiClient'
import type {
  AuditEvent,
  DryRunRequest,
  DryRunResult,
  Interchange,
} from '../types/interchange'

export function getInterchanges(): Promise<Interchange[]> {
  return apiClient.get<Interchange[]>('/api/v1/interchange')
}

export function getAuditHistory(interchangeId: string): Promise<AuditEvent[]> {
  return apiClient.get<AuditEvent[]>(`/api/v1/interchange/${interchangeId}/audit-history`)
}

export function runDryRun(
  interchangeId: string,
  payload: DryRunRequest
): Promise<DryRunResult> {
  return apiClient.post<DryRunResult>(`/api/v1/interchange/${interchangeId}/dry-run`, payload)
}
